import React from 'react';
import PageLayout from '../components/PageLayout';
import { useSEO } from '../hooks/useSEO';
import { CONTACT_EMAIL, KOFI_URL } from '../config';

const Contact: React.FC = () => {
  useSEO(
    'Contact — Purgr',
    'Get in touch with the Purgr team. We typically respond within 48 hours.'
  );

  return (
    <PageLayout title="Contact">
      <div className="space-y-5 text-white/70 text-sm leading-relaxed">
        <p className="text-white/80 text-base">
          Have a question, found a bug, or just want to say hi? We'd love to hear from you.
        </p>

        {/* Email */}
        <div className="glass-card p-6">
          <div className="flex items-start gap-4">
            <div className="text-2xl">✉️</div>
            <div>
              <p className="text-white/90 font-semibold mb-1">Email</p>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="text-white/60 hover:text-white/90 underline transition-colors"
              >
                {CONTACT_EMAIL}
              </a>
              <p className="text-white/40 text-xs mt-2">We typically respond within 48 hours.</p>
            </div>
          </div>
        </div>

        {/* Ko-fi */}
        <div className="glass-card p-6">
          <div className="flex items-start gap-4">
            <div className="text-2xl">☕</div>
            <div>
              <p className="text-white/90 font-semibold mb-1">Support on Ko-fi</p>
              <p className="text-white/55 mb-3">
                Purgr is free to use. If it's been helpful to you, a small tip helps keep it running and ad-free.
              </p>
              <a
                href={KOFI_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gradient inline-block text-white font-bold px-5 py-2 rounded-full text-xs"
              >
                Buy me a coffee →
              </a>
            </div>
          </div>
        </div>

        {/* Bug reports */}
        <div className="glass-card p-5">
          <p className="text-white/90 font-semibold mb-2">🐛 Reporting a bug</p>
          <p className="text-white/55">
            If Purgr isn't parsing your Instagram files correctly, please include:
          </p>
          <ul className="mt-2 space-y-1 text-white/50 list-disc list-inside">
            <li>The format of your files (JSON or HTML)</li>
            <li>The error message shown, if any</li>
            <li>Your browser name and version</li>
          </ul>
          <p className="text-white/40 text-xs mt-3">
            Please don't attach your actual Instagram data files to bug reports — we don't need them, and your data is private.
          </p>
        </div>

        {/* Links */}
        <div className="glass-card p-5">
          <p className="text-white/90 font-semibold mb-3">Useful links</p>
          <div className="space-y-2 text-white/55">
            <a href="/privacy" className="block hover:text-white/80 transition-colors">Privacy Policy →</a>
            <a href="/terms" className="block hover:text-white/80 transition-colors">Terms of Service →</a>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Contact;
